// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2umCV","menu":"Header_menu__Z7_eG","list":"Header_list__Mu4mX","logo":"Header_logo__3VgmS"};